module.exports = __webpack_public_path__ + "img/icon_clean.23a93b4d.svg";